var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_6910_20830)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#122961"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    stroke: "#122961"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5638 14.9045L15.5351 13.2461C15.1425 13.025 14.6758 13.0291 14.2879 13.256C13.8988 13.4835 13.6673 13.8878 13.6673 14.3381V17.6625C13.6673 18.1128 13.8988 18.5171 14.2879 18.7446C14.4862 18.8607 14.7044 18.9178 14.922 18.9178C15.1308 18.9178 15.3397 18.8648 15.5292 18.758L18.5696 17.0932C18.9703 16.868 19.2089 16.4597 19.2089 16.0006C19.2089 15.5415 18.9703 15.1332 18.5643 14.9051L18.5638 14.9045ZM18.0032 16.0729L14.9628 17.7383C14.9518 17.7442 14.9179 17.7628 14.8771 17.7378C14.8339 17.7127 14.8339 17.6753 14.8339 17.6631V14.3387C14.8339 14.3264 14.8339 14.2891 14.8771 14.264C14.8928 14.2547 14.9074 14.2518 14.9203 14.2518C14.9413 14.2518 14.9582 14.2611 14.9687 14.2669L17.9973 15.9259C18.0084 15.9323 18.0417 15.951 18.0417 16.0018C18.0417 16.0525 18.0078 16.0712 18.0032 16.0747V16.0729ZM16 9C12.1401 9 9 12.1401 9 16C9 19.8599 12.1401 23 16 23C19.8599 23 23 19.8599 23 16C23 12.1401 19.8599 9 16 9ZM16 21.8333C12.7835 21.8333 10.1667 19.2165 10.1667 16C10.1667 12.7835 12.7835 10.1667 16 10.1667C19.2165 10.1667 21.8333 12.7835 21.8333 16C21.8333 19.2165 19.2165 21.8333 16 21.8333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_6910_20830",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.835294 0 0 0 0 0.8 0 0 0 0 0.992157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6910_20830"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/playIcon.12b0a24643ef2053fac98a89079587b0.svg";
export { ForwardRef as ReactComponent };